import 'owa-polyfills/lib/configurator';
import 'owa-shared-start/lib/owaPolyfills';
import 'whatwg-fetch';
/**
 Some Headers/fetch related bug was seen in some browsers so
 Hypothesis:
 adding fetch as it is removed in owaPolyfills, with following code:
 if (isEdge) {
        delete window.fetch;
 }
 in case of edge, and
 import api will internally use fetch if import is not supported in a browser.
 So bundle size will increase.
 **/
import 'promise-polyfill';

/**
 * apiTests are mapped to corresponding apiPolyfillPromise array
 * An Object is not for mapping, as then to iterate, Object.keys or for...in loop might not be supported in some browsers
 * and this is the first code that runs on client, when polyfills have not loaded,
 * So, effectively an es3 version of javascript, after transpilation, should land on client
 */
const apiTests = [
    'IntersectionObserver' in window,
    'Symbol' in window,
    'Map' in window,
    'Set' in window,
    Object && Object.entries,
    Object && Object.values,
    'WeakMap' in window,
    'requestAnimationFrame' in window,
    'find' in Array.prototype,
    'scrollBy' in Element.prototype,
    Array.prototype.includes,
    Number.isInteger,
    String.prototype.codePointAt,
];
const apiPolyfillPromise = [
    () => import(/* webpackChunkName: "IntersectionObserverPolyfill" */ 'intersection-observer'),
    () => import(/* webpackChunkName: "SymbolPolyfill" */ 'core-js/es/symbol'),
    () => import(/* webpackChunkName: "MapPolyfill" */ 'core-js/es/map'),
    () => import(/* webpackChunkName: "SetPolyfill" */ 'core-js/es/set'),
    () => import(/* webpackChunkName: "EntriesPolyfill" */ 'core-js/es/object/entries'),
    () => import(/* webpackChunkName: "ValuesPolyfill" */ 'core-js/es/object/values'),
    () => import(/* webpackChunkName: "ValuesPolyfill" */ 'core-js/es/weak-map'),
    () => import(/* webpackChunkName: "RafPolyfill" */ 'raf/polyfill'),
    () => import(/* webpackChunkName: "ArrayFindPolyfill" */ 'core-js/es/array/find'),
    () => import(/* webpackChunkName: "ElementScrollPolyfill" */ 'element-scroll-polyfill'),
    () =>
        new Promise((resolve, reject) =>
            require.ensure(
                ['owa-polyfills/lib/array.prototype.includes'],
                resolve,
                reject,
                'IncludesPolyfill'
            )
        ),
    () =>
        new Promise((resolve, reject) =>
            require.ensure(
                ['owa-polyfills/lib/number.isInteger'],
                resolve,
                reject,
                'IsIntegerPolyfill'
            )
        ),
    () =>
        new Promise((resolve, reject) =>
            require.ensure(
                ['owa-polyfills/lib/string.prototype.codePointAt'],
                resolve,
                reject,
                'CodePointAtPolyfill'
            )
        ),
];
const LoadPolyfillIfNeeded = (apiTest, importPromise) =>
    apiTest ? Promise.resolve() : importPromise();

export const loadPolyfills = function () {
    const promises = apiTests.map((apiTest, index) =>
        LoadPolyfillIfNeeded(apiTest, apiPolyfillPromise[index])
    );

    return Promise.all(promises);
};
